document.addEventListener('DOMContentLoaded', function() {
    var parallaxSections = document.querySelectorAll('.parallax-section');

    window.addEventListener('scroll', function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var windowHeight = window.innerHeight;

        parallaxSections.forEach(function(section) {
            var rect = section.getBoundingClientRect();
            var sectionTop = rect.top + scrollTop;
            var speed = section.getAttribute('data-speed');
            var position = section.getAttribute('data-position');
            var translateY = 0;

            // Calculate translateY based on the specified position
            if (position === 'top') {
                translateY = (scrollTop - sectionTop) * speed;
            } else if (position === 'middle') {
                translateY = (scrollTop - sectionTop + windowHeight / 2) * speed;
            } else if (position === 'bottom') {
                translateY = (scrollTop - sectionTop + windowHeight) * speed;
            }

            var scale = 1 + (scrollTop * 0.0001); // Adjust the scaling factor as needed
            section.style.transform = 'translate3d(0px, ' + translateY + 'px, 0px) scale(' + scale + ')';
        });
    });
});